var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed left-0 right-0 bb-min-h2pt5 bb-lh2pt5 center bb-ff3 bb-fs1pt13 bb-fc1 bb-transition2\n\tbb-zindex2",class:[ _vm.success ? 'bb-bc6' : 'bb-bc7' ]},[_vm._v("\n\t"+_vm._s(_vm.msg)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf5e01f4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/miniNotification.vue
// module id = mYO3
// module chunks = 1